export class NpFilterUtils {



    /**
     * 
     * @param data 실제 데이터 값
     * @param value 필터로 입력된 값 
     * @returns 
     */
    static defaultValidFilterFn(data: any, value: any) {
        value = value ?? '';

        const valueStr = value + '';
        const dataStr = data + '';

        if (!valueStr) {
            return true;
        }
        if (!dataStr) {
            return false;
        }
        return dataStr.toLowerCase().indexOf(valueStr.toLowerCase()) > -1;
    }

}